/* eslint-disable no-use-before-define */
/* eslint-disable require-yield */
import { all, put, takeLatest } from 'redux-saga/effects';
import API_ENDPOINTS from '../../../config/API-endpoints';
import { getCookie } from '../../../utils';
import { fetcherAction } from '../fetcher/creator';
import { trackerActions, trackerConstants } from './creator';

const candidateTrackerAPI = {
  getCandidatesConnectedData: (payload, params = {}) => ({
    tokenize: true,
    fetcherParams: {
      method: 'get',
      url: API_ENDPOINTS.analyticsTrackerCandidateContacted + payload.jobId,
      data: {
 ...payload, from: 0, size: 50, ...params,
},
    },
    headers: {
      Authorization: getCookie('authToken'),
      'Content-Type': 'application/json',
    },
  }),
  getCandidatesAppliedData: (payload, params = {}) => ({
    tokenize: true,
    fetcherParams: {
      method: 'get',
      url: API_ENDPOINTS.analyticsTrackerCandidateApplied + payload.jobId,
      data: {
 ...payload, from: 0, size: 50, ...params,
},
    },
    headers: {
      Authorization: getCookie('authToken'),
      'Content-Type': 'application/json',
    },
  }),
  getCandidatesHiredData: (payload, params = {}) => ({
    tokenize: true,
    fetcherParams: {
      method: 'get',
      url: API_ENDPOINTS.analyticsTrackerCandidateHired + payload.jobId,
      data: {
 ...payload, from: 0, size: 50, ...params,
},
    },
    headers: {
      Authorization: getCookie('authToken'),
      'Content-Type': 'application/json',
    },
  }),
};

function* handleLocationChange({ payload }) {
  return payload;
}

export default function* trackerSagas() {
  yield all([
    // LOAD_CANDIDATES_CONNECTED
    takeLatest(trackerConstants.LOAD_CANDIDATES_CONNECTED.TRIGGER, connected),
    takeLatest(
      trackerConstants.LOAD_CANDIDATES_CONNECTED.SUCCESS,
      connectedOnSuccess,
    ),
    takeLatest(
      trackerConstants.LOAD_CANDIDATES_CONNECTED.FAILURE,
      connectedOnFailure,
    ),

    // LOAD_CANDIDATES_APPLIED
    takeLatest(trackerConstants.LOAD_CANDIDATES_APPLIED.TRIGGER, applied),
    takeLatest(
      trackerConstants.LOAD_CANDIDATES_APPLIED.SUCCESS,
      appliedOnSuccess,
    ),
    takeLatest(
      trackerConstants.LOAD_CANDIDATES_APPLIED.FAILURE,
      appliedOnFailure,
    ),

    // LOAD_CANDIDATES_HIRED
    takeLatest(trackerConstants.LOAD_CANDIDATES_HIRED.TRIGGER, hired),
    takeLatest(trackerConstants.LOAD_CANDIDATES_HIRED.SUCCESS, hiredOnSuccess),
    takeLatest(trackerConstants.LOAD_CANDIDATES_HIRED.FAILURE, hiredOnFailure),

    // to use below pattern, 'connected-react-router' is required in dependencies.
    takeLatest('@@router/LOCATION_CHANGE', handleLocationChange),
  ]);
}

// LOAD_CANDIDATES_CONNECTED
function* connected({ payload }) {
  return yield put(
    fetcherAction({
      ...candidateTrackerAPI.getCandidatesConnectedData(payload),
      label: trackerConstants.LOAD_CANDIDATES_CONNECTED,
    }),
  );
}

function* connectedOnSuccess({ response }) {
  yield put(trackerActions.setCandidatesConnectedData(response));
}

function* connectedOnFailure({ reqPayload, response }) {
  // eslint-disable-next-line no-console
  console.log('==> connectedOnFailure Failure', reqPayload, response);
}

// LOAD_CANDIDATES_APPLIED
function* applied({ payload }) {
  return yield put(
    fetcherAction({
      ...candidateTrackerAPI.getCandidatesAppliedData(payload),
      label: trackerConstants.LOAD_CANDIDATES_APPLIED,
    }),
  );
}

function* appliedOnSuccess({ response }) {
  yield put(trackerActions.setCandidatesAppliedData(response));
}

function* appliedOnFailure({ reqPayload, response }) {
  // eslint-disable-next-line no-console
  console.log('==> appliedOnFailure Failure', reqPayload, response);
}

// LOAD_CANDIDATES_HIRED
function* hired({ payload }) {
  return yield put(
    fetcherAction({
      ...candidateTrackerAPI.getCandidatesHiredData(payload),
      label: trackerConstants.LOAD_CANDIDATES_HIRED,
    }),
  );
}

function* hiredOnSuccess({ response }) {
  yield put(trackerActions.setCandidatesHiredData(response));
}

function* hiredOnFailure({ reqPayload, response }) {
  // eslint-disable-next-line no-console
  console.log('==> hiredOnFailure Failure', reqPayload, response);
}
